import { DtGis } from '@ow/ditto-core'

const { transformer } = DtGis
export { default as Render } from './render'
export { transformer }
